// Generated by ReScript, PLEASE EDIT WITH CARE


var estimate_sub_title = "Please fill in the details, so we can provide you with the best of our services";

var two_wheeler_title_mobile = "Your Quote is a step away!";

var recaptcha_error_message_text = "Error in fetching token. Please refresh the page.";

var vehicle_trucks_source = "trucks_fare_estimate";

var two_wheeler_source = "home_2W";

var trucks_wheeler_source = "home_Trucks";

var spot_source = "spot lead flow";

var form_submit_ga_event_prefix = "Get Trip Estimate Click - ";

var pnm_title = "Packers & Movers";

var pnm_sub_title = estimate_sub_title;

var pnm_title_mobile = two_wheeler_title_mobile;

export {
  recaptcha_error_message_text ,
  vehicle_trucks_source ,
  two_wheeler_source ,
  trucks_wheeler_source ,
  spot_source ,
  form_submit_ga_event_prefix ,
  estimate_sub_title ,
  two_wheeler_title_mobile ,
  pnm_title ,
  pnm_sub_title ,
  pnm_title_mobile ,
}
/* No side effect */
